'use strict';
// The header remains clear while its proportions follow the scroll continuously.
(() => {
 let nav=document.querySelector('.nav');
 if(!nav)return;
 let scheduled=false;
 const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
 function markTone(){
  const y=Math.min(innerHeight-1,Math.max(4,Math.round(nav.getBoundingClientRect().height*.48)));
  const element=document.elementsFromPoint(innerWidth/2,y).find(el=>!nav.contains(el)&&!el.closest('dialog,.buy-sticky,.cart-notice'));
  if(!element)return 'light';
  const marked=element.closest('[data-nav-tone]');
  if(marked)return marked.dataset.navTone==='dark'?'dark':'light';
  for(let el=element;el;el=el.parentElement){
   const rgba=getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
   if(rgba&&rgba.length>=3&&(rgba.length<4||Number(rgba[3])>.5)){
    return (Number(rgba[0])*.2126+Number(rgba[1])*.7152+Number(rgba[2])*.0722)<135?'dark':'light';
   }
  }
  return 'light';
 }
 function update(){
  scheduled=false;nav=document.querySelector('.nav');if(!nav)return;
  const mobile=matchMedia('(max-width:760px)').matches;
  const progress=clamp(scrollY/(mobile?88:132),0,1);
  const startHeight=mobile?86:100,endHeight=mobile?68:74;
  const startWidth=mobile?184:216,endWidth=mobile?160:188;
  nav.style.setProperty('--nav-height-live',`${startHeight+(endHeight-startHeight)*progress}px`);
  nav.style.setProperty('--brand-width-live',`${startWidth+(endWidth-startWidth)*progress}px`);
  nav.style.setProperty('--nav-side-live',mobile?'5%':`${5.2-.8*progress}%`);
  nav.dataset.tone=markTone();
  nav.dataset.atTop=String(scrollY<20);
  nav.classList.toggle('scrolled',progress>.02);
  document.body.classList.toggle('nav-scrolled',progress>.02);
 }
 const queue=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update)}};
 addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue);addEventListener('load',queue);document.addEventListener('shopify:section:load',queue);update();
})();

(() => {
 if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const targets=document.querySelectorAll('.spotlight-copy,.spotlight-picture,.portal,.finder-invite>div,.performance-heading,.performance-facts article,.discovery-copy,.discovery-image,.house-image,.house-copy,.feeling-art,.feeling-copy,.journey-phases article,.scent-ritual>div,.ritual-gate,.scent-scene>img,.scent-scene>div');
 if(!targets.length)return;
 const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}},{threshold:.08,rootMargin:'0px 0px -8% 0px'});
 targets.forEach((element,index)=>{element.style.setProperty('--reveal-delay',`${index%2?90:0}ms`);element.classList.add('scroll-reveal');observer.observe(element)});
})();

